<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'KlFormRow',
    props: {
        modStacked: { type: Boolean, required: false, default: true }
    }
});
</script>

<template>
    <vl-column>
        <vl-form-grid :mod-stacked="modStacked">
            <slot></slot>
        </vl-form-grid>
    </vl-column>
</template>

<style scoped lang="scss">

</style>
